import React, { useMemo, useState } from "react";
import moment from "moment";
import CalendarLayout from "../../Layout/CalendarLayout/CalendarLayout";
import { useRequestProcessor } from "../../requestProcessor";
import { useAtom } from "jotai";
import { activeChildDetail, ActivityAtom } from "../../AtomStore/store";
import { fetchDailyFeed } from "../../QueryFunctions/queryfunction";
import ActivityCalenderItem from "./Item";
import ListEmptyComponent from "../../Layout/LoggedInLayout/ListEmptyComponent";
import SpinnerLoading from "../../Components/utils/SpinnerLoading";
import { SERVER_DATE_FORMAT } from "../Support/TakeABreak/TakeABreak";

const ActivityCalendar = () => {
  const { useQueryWrapper } = useRequestProcessor();
  const [activeChild] = useAtom(activeChildDetail);
  const [dailyFeed, setDailyFeed] = useAtom(ActivityAtom);
  const [selectedDate, setSelectedDate] = useState(
    moment().format(SERVER_DATE_FORMAT)
  );

  useMemo(() => {
    console.log(
      `[Activity Calendar] Fetching Activity Calendar details for user: ${activeChild?.id}`
    );
  }, [activeChild]);

  const { isLoading } = useQueryWrapper(
    ["dailyFeed", activeChild?.id, selectedDate],
    () => fetchDailyFeed(selectedDate),
    {
      onSuccess: (data) => {
        setDailyFeed(data);
      },
    }
  );
  return (
    <CalendarLayout
      setSelectedDate={setSelectedDate}
      selectedDate={selectedDate}
    >
      {isLoading ? <SpinnerLoading /> : ""}
      {Array.isArray(dailyFeed) && dailyFeed?.length > 0 && (
        <div className="">
          {dailyFeed.map((item, index) => (
            <>
              <ActivityCalenderItem item={item} index={index} key={index} />
              <hr className="my-2 w-full bg-dark text-dark" />
            </>
          ))}
        </div>
      )}
      {isLoading ? (
        <div className="text-center mt-4 h-[30vh]">
          <ListEmptyComponent heading="Loading..." />
        </div>
      ) : dailyFeed?.length === 0 ? (
        <div className="text-center mt-4 h-[30vh]">
          <ListEmptyComponent
            heading={
              moment(selectedDate).day() === 0 ||
              moment(selectedDate).day() === 6
                ? "No activity on weekends"
                : "No Data Found"
            }
          />
        </div>
      ) : null}
    </CalendarLayout>
  );
};

export default ActivityCalendar;
